import DesignChangeDialog from './DesignChangeDialog.vue'

export default DesignChangeDialog
